// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iYTnd","col":"styles_col__2YJua"};